module.exports = __webpack_public_path__ + "static/media/codePieChartRandomized.61059c38.gif";